import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getMultiSelectRequest, setMultiSelectValue } from "../../misc/MultiSelectRequest";
import { useNavigate } from "react-router";
import PopupLoader from "../../PopupLoader";
import MultiSaveLimitAlert from "../../../../apiclients/MultiSaveLimitAlert";

const AddtoUserGroup = forwardRef((props, ref) => {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [groupsList, setgroupsList] = useState([]);
    const [warningMsg, setwarningMsg] = useState([]);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [groupid, setgroupid] = useState(-1);
    const [showWarning, setShowWarning] = useState(false);
    const [groupType, setGroupType] = useState(null);
    const warningToggle = () => setShowWarning(!showWarning);
    const [optionList, setOptionList] = useState([]);

    const [saveWarningMessage, setsaveWarningMessage] = useState("");
    const [allEntriesDicard, setAllEntriesDicard] = useState(false);

    useEffect(() => {
        getAllGroups();

    }, []);

    async function getAllGroups() {
        props.setIsloading(true);
        const tdata = await getMultiSelectRequest(9, props.agentList, props.moduleType);
        props.setIsloading(false);
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }

        const reponseData = tdata?.result?.option_list ?? [];
        console.log("all group list :::::::::::: " + JSON.stringify(reponseData));
        const actuallist = reponseData.flatMap(groupTypeObject =>
            Object.keys(groupTypeObject).flatMap(groupTypeKey => {
                const groups = groupTypeObject[groupTypeKey];
                return Array.isArray(groups) ? groups : [];
            })
        );
        setOptionList(actuallist);

        const processedList = reponseData.flatMap((groupTypeObject) => {
            return Object.keys(groupTypeObject).flatMap((groupTypeKey) => {
                const groups = groupTypeObject[groupTypeKey];
                if (Array.isArray(groups)) {
                    return groups.map((group) => {
                        if (groupTypeKey === "user_groups") {
                            return { id: group.code, value: `${group.title} : ${group.category}` };
                        } else {
                            return { id: group.code, value: `${group.title} : ${group.extensions} : ${group.category}` };
                        }
                    });
                }
                return [];
            });
        });
        setgroupsList(processedList ?? []);
        setwarningMsg(tdata?.result?.message ? [tdata?.result?.message] : []);
    }
    async function handleGroupChange(value, type) {
        setGroupType(type)
        props.setIsloading(true);
        const tdata = await setMultiSelectValue(9, value + "", props.agentList, props.moduleType, null, null, null, type);
        props.setIsloading(false);
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        console.log("handleGroupChange for multi select ::::::::::::: " + JSON.stringify(tdata));
        const reponseMsg = tdata.display_Info ?? [];
        if (reponseMsg.length > 0) {
            setwarningMsg(reponseMsg);
        }
    }

    async function onsubmit(confirmFlag) {
        if (parseInt(groupid) === -1) {
            setError("Please select a Group");
            return;
        }
        let tdata = null;
        props.setIsloading(true);
        if (confirmFlag) {
            tdata = await setMultiSelectValue(9, groupid + "", props.agentList, props.moduleType, 1, 1, null, groupType);
        } else {
            tdata = await setMultiSelectValue(9, groupid + "", props.agentList, props.moduleType, 1, null, null, groupType);
        }
        props.setIsloading(false);
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        if (tdata.status == "Failed") {
            localStorage.setItem(
                "user_create_f",
                "Something went wrong, Please try again after sometime"
            );
            props.onClose();
            window.location.href = "/userlanding";
        } else if (tdata.status == "failed") {
            if (tdata.exceededErrMsg) {
                setsaveWarningMessage(tdata.exceededErrMsg);
                if(tdata.all_grps_discarded) {
                    setAllEntriesDicard(true);
                }
                warningToggle();
                return;
            }
        } else {
            console.log("groupid for multi select ::::::::::::: " + JSON.stringify(tdata));
            localStorage.setItem("s_message", tdata.message);

            if (props.locUser) {
                navigate("/locationsusers", {
                    state: { tab: props.locUser },
                });

            } else if (props.groupInfo) {
                navigate("/usersgroups", {
                    state: { tab: props.groupInfo },
                });

            } else if (props.groupUInfo) {
                navigate("/SelectedUserGroupSettings", {
                    state: { tab: "tab2", groupUInfo: props.groupUInfo },
                });

            } else if (props.usergroups) {
                navigate("/userlanding", {
                    state: { tab: "mgroups" },
                });

            } else if (props.userLoc) {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "sloc" },
                });

            } else if (props.userAllgroups) {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "sgroups" },
                });



            } else {
                navigate("/userlanding", {
                    state: { tab: "suser", tab2: "suser" },
                });
            }
            props.onClose();

            window.location.reload();
        }



    }
    return (
        <>
            <div className="w-100" style={{ paddingBottom: 125 }}>
                <div className=" ">
                    <strong className=" d-block">
                        {t("Group")}
                    </strong>
                    <select
                        className="form-select form-control mt-2 w-100"
                        name="408 702 2241"
                        value={groupid}
                        onChange={(e) => {
                            setgroupid(e.target.value);
                            const groupType = optionList.find((list) => parseInt(list.code) === parseInt(e.target.value))?.group_type ?? null

                            if (parseInt(e.target.value) === -1) {
                                setError("Please select a Group");
                            } else {
                                setError("");
                                handleGroupChange(e.target.value, groupType);
                            }
                        }}
                    >
                        <option value={-1}>-- Select Group --</option>
                        {groupsList && groupsList.map(group => (
                            <option value={group.id}>
                                {group.value}
                            </option>
                        ))}

                    </select>
                    {error && (
                        <p className="text-danger">{error}</p>
                    )}
                </div>
                {warningMsg && warningMsg.map((meg) => (
                    <div className="pt-2 phrecording">
                        {meg}
                    </div>
                ))}
            </div>
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => {
                    e.preventDefault();
                    onsubmit();
                }}>
                    {t("add")}</button>
            </div>
            {showWarning && (
                <>
                    <PopupLoader
                        title="Warning"
                        content={
                            <MultiSaveLimitAlert
                                saveWarningMessage={saveWarningMessage}
                                onClose={warningToggle}
                                handleClick={() => { if(allEntriesDicard) {warningToggle(); props.onClose(); return;}onsubmit(1);}}
                            />
                        }
                        onShow={setShowWarning}
                        onClose={warningToggle}
                    />

                </>
            )}
        </>
    )
});
export default AddtoUserGroup
